import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propShape, propArrayShape, propBool, propChildren, propFunc, propNumber, propStr, } from '../../../../../../helpers/custom-prop-types';
import GoodIcon from '../../../../../Icon/Svg/GoodIcon';
import InputRange from '../../../../../Ui/Input/InputRange';
import CharmPointStep from './CharmPointStep';
const CharmPointRow = (props) => {
    const { arrowColor, bottomRowClassName, charmPoint, charmPoints, driverTargetRef, isActiveDriverTarget, isDisabled, label, onChange, onChangeComplete, onClickDriverTarget, orientation, topRowClassName, } = props;
    const showAvg = useMemo(() => {
        if (!charmPoint && !charmPoints.length) {
            return 'ー';
        }
        const otherValues = charmPoints.filter((v) => !v.is_self);
        const otherSum = otherValues.reduce((accumulator, currentValue) => accumulator + currentValue.charm_point, charmPoint || 1);
        const averageCharmPoint = otherSum / (otherValues.length + 1);
        const fixedValue = averageCharmPoint.toFixed(1);
        if (fixedValue === '0.0') {
            return 'ー';
        }
        return fixedValue;
    }, [charmPoint, charmPoints]);
    return (_jsxs("div", Object.assign({ className: clsx('charmpoint_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: [_jsxs("div", Object.assign({ className: clsx('charmpoint_top_row', topRowClassName) }, { children: [_jsx(GoodIcon, {}), _jsx("span", Object.assign({ className: 'label_value' }, { children: label })), _jsx("span", Object.assign({ className: 'number_value' }, { children: charmPoint || 1 })), _jsx("span", Object.assign({ className: 'average_value' }, { children: `（平均：${showAvg}）` }))] })), _jsx("div", Object.assign({ className: clsx('charmpoint_bottom_row', bottomRowClassName) }, { children: _jsx(InputRange, { arrowColor: arrowColor, max: 5, min: 1, onChange: onChange, onChangeComplete: onChangeComplete, orientation: orientation, showHandle: !isDisabled, stepElement: _jsx(CharmPointStep, { arrowColor: arrowColor, showTip: orientation === 'horizontal' }), tooltip: false, value: charmPoint || 1 }) }))] })));
};
CharmPointRow.propTypes = {
    arrowColor: propStr(),
    bottomRowClassName: propStr(),
    charmPoint: propNumber().isRequired,
    charmPoints: propArrayShape().isRequired,
    driverTargetRef: propShape(),
    isActiveDriverTarget: propBool(),
    isDisabled: propBool().isRequired,
    label: propChildren(),
    onChange: propFunc().isRequired,
    onChangeComplete: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
    orientation: propStr(),
    topRowClassName: propStr(),
};
CharmPointRow.defaultProps = {
    arrowColor: '',
    bottomRowClassName: '',
    driverTargetRef: null,
    isActiveDriverTarget: false,
    label: '提案魅力度',
    onClickDriverTarget: undefined,
    orientation: 'horizontal',
    topRowClassName: '',
};
export default CharmPointRow;
